import { render } from "./App.vue?vue&type=template&id=866aff4a&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=866aff4a&lang=less&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\Bolia.Website\\clients\\app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-866aff4a"]])

export default __exports__